<template>
  <div>
    <b-modal ref="editsitemodal" modal-class="editsitemodal" centered  title="Edit Site Details" ok-title="Save changes" @ok="saveChanges()" @shown="loadInitialData" :hide-header-close="true" :hide-footer="true" no-fade>
      <b-tabs pills card vertical v-model="tabIndex">
        <b-tab v-for="(menu,$index) in menus" :title="menu.name" :key="$index" @click="loadCurrentComponent(menu.component)">
          <component v-if="tabIndex==$index" :is="currentComponent"  :url="menu.location" v-model="currentSite"></component>
        </b-tab>

      </b-tabs>
      <div class="w-100 modal-footer">
        <div class="text-right">
          <b-btn variant="flat" @click="close()">
            Cancel
          </b-btn>
          <b-btn variant="primary" @click="saveChanges()" :disabled="buttonLoader.saveChanges">
            Save Changes
            <spinner size="small" v-if="buttonLoader.saveChanges"></spinner>
          </b-btn>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import WpAdminDetails from '../Common/WpAdminDetails';
import AssignGroups from '../Common/AssignGroups';
import FolderProtection from '../Common/FolderProtection';
import Advanced from '../Common/Advanced';
import SiteAlias from '../Common/SiteAlias';
import FTPDetails from '../Common/FTPDetails';

import { EventBus } from '../../event/event-bus.js';
import Utils from '../../mixins/utils';

export default {
  name: 'editsite',
  props: ['site'],
  components: {
    WpAdminDetails,
    AssignGroups,
    FolderProtection,
    Advanced,
    SiteAlias,
    FTPDetails
  },
  mounted() {},
  mixins: [Utils],
  data() {
    return {
      currentSite: {},
      tabIndex: 0,
      buttonLoader: {
        saveChanges: false
      },
      currentComponent:'WpAdminDetails',
      defaultSlugs: [
        'WpAdminDetails',
        'AssignGroups',
        'FolderProtection',
        'Advanced',
        'SiteAlias',
        'FTPDetails'
      ]
    };
  },
  computed:{
    menus(){
      return this.$store.getters.getEditSiteMenu;
    }
  },
  methods: {
    loadInitialData() {
      this.currentSite = _.cloneDeep(this.site);

      this.tabIndex = 0;
      this.currentComponent = 'WpAdminDetails';
    },
    saveChanges() {
      let payload = {};
      let requiredData = {};
      this.buttonLoader.saveChanges = true;
      requiredData['updateSite'] = {
        URL_b64encoded: btoa(this.currentSite.URL),
        siteID: this.currentSite.siteID,
        adminURL_b64encoded: btoa(this.currentSite.adminURL),
        groupIDs: this.currentSite.groupIDs,
        adminUsername: this.currentSite.adminUsername,
        connectURL: this.currentSite.connectURL,
        callOpt: this.currentSite.callOpt,
        siteName: this.currentSite.name,
        httpAuth: this.currentSite.httpAuth
      };
      if (typeof this.currentSite.ftpDetails != 'undefined' && this.currentSite.ftpDetails != null && typeof this.currentSite.ftpDetails.hostName != 'undefined' && this.currentSite.ftpDetails.hostName != null) {
        requiredData['saveSiteFtpDetails'] = {
          hostName: this.currentSite.ftpDetails.hostName,
          hostPort: this.currentSite.ftpDetails.hostPort,
          hostUserName: this.currentSite.ftpDetails.hostUserName,
          hostPassword: this.currentSite.ftpDetails.hostPassword,
          remoteFolder: this.currentSite.ftpDetails.remoteFolder,
          newSiteURL: this.currentSite.ftpDetails.newSiteURL,
          hostPassive: this.currentSite.ftpDetails.hostPassive,
          hostSSL: this.currentSite.ftpDetails.use_ftpssl,
          use_ftp: this.currentSite.ftpDetails.use_ftp,
          use_sftp: this.currentSite.ftpDetails.use_sftp,
          siteID: this.currentSite.siteID,
          sourceSiteID: this.currentSite.siteID,
          toIWP: 1
        };
      }
      EventBus.$emit('edit-site-save-changes', this.currentSite);
      requiredData.getSitesUpdatesV3 = 1;
      requiredData.getClientUpdateAvailableSiteIDs = 1;
      requiredData.getGroupsSitesV3 = 1;
      requiredData.getSitesV3 = 1;
      requiredData.getPluginsAndThemesV3 = 1;

      payload.requiredData = requiredData;
      this.$store.dispatch('sendAction', payload).then(response => {
        this.buttonLoader.saveChanges = false;
        let actionData = response.data;
        _.forEach(actionData, (actionDataItem, actionDataKey) => {
          let mutationKey = this.getMutationBasedOnKey(actionDataKey);
          if (mutationKey) {
            this.$store.commit(mutationKey, actionDataItem);
          }
        });
        this.close();
      });
    },
    close() {
      this.$refs.editsitemodal.hide();
    },
    loadCurrentComponent(menuSlug){
      if (this.defaultSlugs.indexOf(menuSlug) > -1) {
        this.currentComponent = menuSlug;
      }
      else {
        this.currentComponent = () =>
          this.loadDynamicMenu(menuSlug).then(module => {
            // this.$store.registerModule(slug, module.default.Store);
            return module.default.EditSiteMenu;
          });
      }
    },
    loadDynamicMenu(menuSlug){
      switch (menuSlug) {
        case "EditSiteAnalytics":
          return import(/* webpackChunkName: 'googleAnalytics/index' */ "@/components/addons/GoogleAnalytics/index");
        case "EditSiteOptimize":
          return import(/* webpackChunkName: 'WPOptimize/index' */ "@/components/addons/WPOptimize/index");  
        case "EditSiteBackup":
          return import(/* webpackChunkName: 'ScheduleBackup/index' */ "@/components/addons/ScheduleBackup/index"); 
        case "EditSiteUser":
          return import(/* webpackChunkName: 'multiUser/index' */ "@/components/addons/MultiUser/index"); 
        default:
          return Promise.resolve("addon_not_supported");
      }
    }
  }
};
</script>

<style>
</style>
